interface Instructor {
  name?: string
  x?: string
}

interface RequestInfo {
  domain: string
  path: string
}

interface SeoMetaTagsArgs {
  title: string
  requestInfo: RequestInfo
  description?: string
  instructor?: Instructor
  ogTitle?: string
  ogDescription?: string
  ogImageUrl?: string
  ogImageAlt?: string
}

function notNull<T>(value: T | null): value is T {
  return value !== null
}

export default function getSeoMetaTags({
  title,
  description,
  instructor,
  requestInfo,
  ogTitle = title,
  ogDescription = description,
  ogImageUrl = `${requestInfo.domain}/og?${new URLSearchParams({
    title: ogTitle,
    subtitle: ogDescription ?? '',
    urlPathname: requestInfo.path,
    version: 'v4'
  }).toString()}`,
  ogImageAlt = title
}: SeoMetaTagsArgs) {
  return [
    { title },
    description ? { description } : null,
    instructor?.name ? { name: 'author', content: instructor.name } : null,
    { name: 'og:site_name', content: title },
    { name: 'twitter:card', content: 'summary_large_image' },
    instructor?.x ? { name: 'twitter:creator', content: instructor.x } : null,
    { name: 'og:title', content: ogTitle },
    description ? { name: 'og:description', content: ogDescription } : null,
    { name: 'og:type', content: 'website' },
    { name: 'og:image:width', content: '1200' },
    { name: 'og:image:height', content: '630' },
    { name: 'og:image:alt', content: ogImageAlt },
    { name: 'og:image', content: ogImageUrl }
  ].filter(notNull)
}
